import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useStoreState } from "pullstate";
import { subscribeUserNotification } from "../../utils/pushNotification";
import InApppAlert from "../InAppAlert";
import Store from "../../utils/Store";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import constants from "../../utils/constants";
import { differenceInMilliseconds } from "date-fns";
import { getFCMToken } from "../../utils";
import { t } from "i18next";
import useSaveNotificationSettings from "../NotificationSettings/services/useSaveNotificationSettings";
import Toast from "../Toast";
import Loader from "../Loader";
import { useRouter } from "next/router";
import LoggedInToken from "../../utils/LoggedInToken";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { useAuth } from "@qure/qure-auth";
var NotificationSubscription = function NotificationSubscription() {
  var _window, _window2;
  var isMobileApp = (_window = window) === null || _window === void 0 ? void 0 : _window.ReactNativeWebView;
  var router = useRouter();
  var _useState = useState(!!localStorage.getItem(constants.PERSISTED.notificationPromptDismiss)),
    isIgnored = _useState[0],
    setIgnored = _useState[1];
  var saveNotificationSettings = useSaveNotificationSettings();
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo,
    refetchProfile = _useAuth.refetchProfile;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        RNfcmToken: s.RNfcmToken,
        isRNAppStateChange: s.isRNAppStateChange,
        RNAppVersion: s.RNAppVersion,
        fcmToken: s.fcmToken,
        isNotificationSubscribing: s.isNotificationSubscribing
      };
    }),
    fcmToken = _useStoreState.fcmToken,
    RNfcmToken = _useStoreState.RNfcmToken,
    isRNAppStateChange = _useStoreState.isRNAppStateChange,
    isNotificationSubscribing = _useStoreState.isNotificationSubscribing;
  var token = RNfcmToken || fcmToken;
  var isLoggedIn = get(userInfo, ["authenticated"], false);
  var hasPermission = isMobileApp && (!!RNfcmToken || RNfcmToken === "") || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.Notification) === null || _window2 === void 0 ? void 0 : _window2.permission) === "granted";
  var isNotificationsOn = !isLoggedIn || !get(userInfo, ["settings", "notification_snoozed"], false);
  var isSubscribed = isNotificationSubscribing || !isLoggedIn && hasPermission || !token && hasPermission || get(userInfo, ["subscription_tokens"], []).some(function (tokenObj) {
    return get(tokenObj, ["token"], "") === token;
  });
  var alertTimeout;
  useEffect(function () {
    if (isLoggedIn) {
      setDefaultFCMTokens();
      setAlertTimer();
      if (LoggedInToken.isLoginProgress()) {
        LoggedInToken.removeLogInProgress();
        updateSubscription();
      }
    }
    return function () {
      clearTimeout(alertTimeout);
    };
  }, [isLoggedIn]);

  // when user change the notification permission of app from device settngs
  useEffect(function () {
    if (isMobileApp && isRNAppStateChange && isLoggedIn) {
      var _hasPermission = !!RNfcmToken;
      if (!hasPermission && _hasPermission) {
        updateSubscription();
      }
    }
  }, [RNfcmToken, isRNAppStateChange]);

  // To nudge users every 6  hours if user has ignored the popup and not enabled notification yet
  var setAlertTimer = function setAlertTimer() {
    if (hasPermission && isSubscribed && isNotificationsOn) {
      return localStorage.removeItem(constants.PERSISTED.notificationPromptDismiss);
    }
    var timeStr = localStorage.getItem(constants.PERSISTED.notificationPromptDismiss);
    if (timeStr) {
      var ignoredTime = new Date(timeStr);
      ignoredTime.setHours(ignoredTime.getHours() + 12);
      var remainingTime = differenceInMilliseconds(ignoredTime, new Date());
      alertTimeout = setTimeout(function () {
        clearTimeout(alertTimeout);
        localStorage.removeItem(constants.PERSISTED.notificationPromptDismiss);
        setIgnored(false);
      }, remainingTime);
    }
  };

  // check if user is subscribed for notification
  var setDefaultFCMTokens = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _window3;
      var _fcmToken;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.Notification) === null || _window3 === void 0 ? void 0 : _window3.permission) === "granted")) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return getFCMToken();
          case 1:
            _fcmToken = _context.v;
            Store.update(function (s) {
              s.fcmToken = _fcmToken;
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function setDefaultFCMTokens() {
      return _ref.apply(this, arguments);
    };
  }();
  var onIgnore = function onIgnore() {
    if (isNotificationSubscribing) {
      return;
    }
    clearTimeout(alertTimeout);
    localStorage.setItem(constants.PERSISTED.notificationPromptDismiss, new Date().toString());
    setIgnored(true);
    setAlertTimer();
    trackEvent(MIXPANEL_EVENTS.IGNORE_NOTIFICATION_FROM_NUDGE, {
      hasPermission: hasPermission,
      isSubscribed: isSubscribed,
      isNotificationsOn: isNotificationsOn
    });
  };
  var updateSubscription = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var subscription;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            Store.update(function (s) {
              s.isNotificationSubscribing = true;
            });
            _context2.n = 1;
            return subscribeUserNotification(RNfcmToken);
          case 1:
            subscription = _context2.v;
            if (!subscription) {
              _context2.n = 2;
              break;
            }
            _context2.n = 2;
            return refetchProfile();
          case 2:
            Store.update(function (s) {
              s.isNotificationSubscribing = false;
            });
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function updateSubscription() {
      return _ref2.apply(this, arguments);
    };
  }();
  var enableGlobalNotifications = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            _context3.n = 1;
            return saveNotificationSettings.mutateAsync({
              notification_snoozed: false
            });
          case 1:
            refetchProfile();
            _context3.n = 3;
            break;
          case 2:
            _context3.p = 2;
            _t = _context3.v;
            Toast.error("Something went wrong. Please try again");
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return function enableGlobalNotifications() {
      return _ref3.apply(this, arguments);
    };
  }();
  var onEnableNotification = function onEnableNotification() {
    if (isNotificationSubscribing) {
      return;
    }
    if (isMobileApp && !hasPermission) {
      var _window4;
      var data = {
        event: constants.RN_COMM_CONST.OPEN_APP_SETTINGS,
        data: null
      };
      (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.ReactNativeWebView) === null || _window4 === void 0 || _window4.postMessage(JSON.stringify(data));
    } else if (isSubscribed && !isNotificationsOn) {
      enableGlobalNotifications();
    } else {
      updateSubscription();
    }
    trackEvent(MIXPANEL_EVENTS.ENABLE_NOTIFICATION_FROM_NUDGE, {
      hasPermission: hasPermission,
      isSubscribed: isSubscribed,
      isNotificationsOn: isNotificationsOn
    });
  };
  return /*#__PURE__*/React.createElement(InApppAlert, {
    show: false,
    message: !hasPermission || !isSubscribed ? t("notification_modal.no_notifications_setting") : t("notification_modal.no_notifications"),
    messageClassName: "!text-gray-800",
    primaryCTA: /*#__PURE__*/React.createElement("a", {
      className: "text-teal-500 cursor-pointer",
      onClick: onEnableNotification
    }, isMobileApp && !hasPermission ? t("notification_modal.enable_settings") : t("notification_modal.turn_on_notification")),
    secondaryCTA: /*#__PURE__*/React.createElement("a", {
      className: "text-gray-600 cursor-pointer",
      onClick: onIgnore
    }, t("notification_modal.ignore")),
    className: "",
    icon: isNotificationSubscribing ? /*#__PURE__*/React.createElement(Loader, {
      size: "medium",
      className: "border-teal-200"
    }) : /*#__PURE__*/React.createElement("svg", {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M22.1437 4.25V5.50719C26.9989 6.31648 30.7156 10.7328 30.7156 16.0625V18.4109C30.7156 21.6031 31.7536 24.7039 33.6488 27.2L34.6466 28.5078C35.035 29.0141 35.1086 29.7102 34.8408 30.2938C34.5729 30.8773 34.0104 31.25 33.3943 31.25H6.60723C5.98912 31.25 5.42626 30.8773 5.15866 30.2938C4.89099 29.7102 4.96626 29.0141 5.35226 28.5078L6.35075 27.2C8.25062 24.7039 9.28594 21.6031 9.28594 18.4109V16.0625C9.28594 10.7328 13.0026 6.31648 17.8578 5.50719V4.25C17.8578 3.00758 18.8154 2 20.0008 2C21.1861 2 22.1437 3.00758 22.1437 4.25ZM19.465 8.75C15.6211 8.75 12.5004 12.0266 12.5004 16.0625V18.4109C12.5004 21.7789 11.5709 25.0625 9.84244 27.875H30.1597C28.432 25.0625 27.5011 21.7789 27.5011 18.4109V16.0625C27.5011 12.0266 24.3804 8.75 20.5365 8.75H19.465ZM24.2867 33.5C24.2867 34.632 23.838 35.8414 23.0344 36.6852C22.2308 37.5289 21.0789 38 20.0008 38C18.8623 38 17.7707 37.5289 16.9671 36.6852C16.1635 35.8414 15.7148 34.632 15.7148 33.5H24.2867Z",
      fill: "#00D0CD"
    }))
  });
};
export default NotificationSubscription;